import type {
  SearchAreaCategory,
  SearchAreaCategories,
  SearchArea,
  ServiceTypeCategory,
  ServiceTypeCategories,
  ServiceType,
  OccupationTypeCategory,
  OccupationTypeCategories,
  OccupationType,
} from "~/types";

export const createCategoryMap = <T extends { key: string }>(
  categories: T[]
): Record<string, T> => {
  return categories.reduce(
    (acc, category) => ({
      ...acc,
      [category.key]: category,
    }),
    {}
  );
};

export const filterByCategory = <T extends { [key: string]: any }>(
  items: T[],
  categoryId: string,
  categoryField: keyof T
): T[] => {
  return items.filter((item) => item[categoryField] === categoryId);
};
